import useLazyRestQuery from "@/remoteState/useLazyRestQuery";
import { buildRequestUrlToFetchTaxonomyData } from "@/search/buildRequestUrlToFetchTaxonomyData";

export const useTaxonomyTagsFetch = (depth: number) => {
  const requestUrl = buildRequestUrlToFetchTaxonomyData({
    include_rels: "children",
    depth,
  });

  return useLazyRestQuery(requestUrl);
};
